import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const HolidayCreateForm= React.lazy(()=>import('./Createform'))
const HolidayEditPage= React.lazy(()=>import('./EditPage'));
const HolidayListingPage= React.lazy(()=>import('./Holidaylisting'))


export const HolidayConfigs = [
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/holiday/create/:id',
    element: <HolidayCreateForm />,
  },
  {
    permittedRole: RoutePermittedRole.corporateAdmin,
    path: '/onboard-corporate/holiday/edit/:id',
    element: <HolidayEditPage/>,
  },
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/onboard-corporate/holiday/list',
    element: <HolidayListingPage/>,
  },
 

];
